function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import IconChevronDown from '~icons/ci/chevron-down';
import { SelectorSelect } from '@arc/frontend/ui-form';
import { theme } from '@arc/frontend/ui-theme';
import { ListPageSelector } from './ListPageSelector';
import { ListPaginationTotal } from './ListPaginationTotal';
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "6n9tmb",
    styles: "display:flex;align-items:center;justify-content:space-between;padding-left:1rem;padding-right:1rem;padding-top:0.5rem;padding-bottom:0.5rem"
  } : {
    name: "1lu1wly-container",
    styles: "display:flex;align-items:center;justify-content:space-between;padding-left:1rem;padding-right:1rem;padding-top:0.5rem;padding-bottom:0.5rem;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  buttonsWrap: process.env.NODE_ENV === "production" ? {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
  } : {
    name: "1fsnsbu-buttonsWrap",
    styles: "display:flex;align-items:center;label:buttonsWrap;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  text: /*#__PURE__*/css({
    color: theme.colors.text.primary,
    fontWeight: '400'
  }, process.env.NODE_ENV === "production" ? "" : ";label:text;"),
  dropDownBtnOptionsWrap: process.env.NODE_ENV === "production" ? {
    name: "1by8trd",
    styles: "position:relative;margin-left:1rem"
  } : {
    name: "1n1vsq1-dropDownBtnOptionsWrap",
    styles: "position:relative;margin-left:1rem;label:dropDownBtnOptionsWrap;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  dropdownBtn: /*#__PURE__*/css({
    backgroundColor: theme.colors.background.paper,
    borderColor: theme.colors.input.border,
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
    borderWidth: '1px',
    display: 'flex',
    alignItems: 'center',
    outline: '2px solid transparent',
    outlineOffset: '2px',
    ':focus': {
      outline: '2px solid transparent',
      outlineOffset: '2px'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:dropdownBtn;"),
  dropdownList: process.env.NODE_ENV === "production" ? {
    name: "wqnph7",
    styles: "box-shadow:0px 4px 8px #0000001f;position:absolute;bottom:0px;left:0px;right:0px;outline:2px solid transparent;outline-offset:2px"
  } : {
    name: "1siop9n-dropdownList",
    styles: "box-shadow:0px 4px 8px #0000001f;position:absolute;bottom:0px;left:0px;right:0px;outline:2px solid transparent;outline-offset:2px;label:dropdownList;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  openList: /*#__PURE__*/css({
    borderColor: theme.colors.input.border,
    borderWidth: '1px',
    outline: '2px solid transparent',
    outlineOffset: '2px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:openList;"),
  dropdownOption: process.env.NODE_ENV === "production" ? {
    name: "1kw2t2i",
    styles: "padding:0.5rem;text-align:left"
  } : {
    name: "1ya2bgi-dropdownOption",
    styles: "padding:0.5rem;text-align:left;label:dropdownOption;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
function useRowsOptions(rowsPerPage, rowsPerPageOptions) {
  const {
    t
  } = useTranslation('common');
  return useMemo(() => {
    // eslint-disable-next-line unicorn/no-array-reduce
    const map = rowsPerPageOptions.reduce((result, rows) => ({
      ...result,
      [t('itemsPerPage', {
        itemsPerPage: rows
      })]: rows
    }), {
      [t('auto')]: null
    });
    const options = Object.keys(map);
    const result = Object.entries(map).find(([, rows]) => rows === rowsPerPage);
    const selectedOption = result ? result[0] : t('itemsPerPage', {
      itemsPerPage: rowsPerPage
    });
    return [options, selectedOption, map];
  }, [rowsPerPageOptions, rowsPerPage, t]);
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1ejri1g",
  styles: "flex-direction:column;align-items:flex-start"
} : {
  name: "1rp7u3-ListPagination",
  styles: "flex-direction:column;align-items:flex-start;label:ListPagination;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "ufxjcp",
  styles: "padding-left:1.5rem"
} : {
  name: "1xpp83z-ListPagination",
  styles: "padding-left:1.5rem;label:ListPagination;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "1ff36h2",
  styles: "flex-grow:1"
} : {
  name: "1eivad8-ListPagination",
  styles: "flex-grow:1;label:ListPagination;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function ListPagination({
  rowsPerPage,
  rowsPerPageOptions,
  totalItems,
  page,
  onChangePage,
  onChangeRowsPerPage,
  sidebarStyle,
  itemType,
  exportButton,
  tableFooter,
  containerRef
}) {
  const [selectorOptions, selectedOption, selectorOptionsLUT] = useRowsOptions(rowsPerPage, rowsPerPageOptions);
  return <div css={[styles.container, sidebarStyle && _ref, process.env.NODE_ENV === "production" ? "" : ";label:ListPagination;"]} ref={containerRef}>
			<div css={styles.buttonsWrap}>
				<ListPaginationTotal totalItems={totalItems} itemType={itemType} sidebarView />

				{sidebarStyle ? null : <SelectorSelect items={selectorOptions} value={selectedOption} onChange={option => {
        const value = selectorOptionsLUT[option];
        onChangeRowsPerPage(value);
      }} testid="pagination-rows-per-page-selector" Icon={IconChevronDown} />}
			</div>
			{exportButton ? <>
					<div css={_ref2}>{exportButton}</div>
					<div css={_ref3} />
				</> : null}

			{tableFooter ?? null}
			<ListPageSelector totalItems={totalItems} rowsPerPage={rowsPerPage} page={page} onChangePage={onChangePage} delta={sidebarStyle ? 0 : undefined} />
		</div>;
}